/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Checkbox } from "@/components/ui/checkbox";
import { useDocument, useDocumentReadOnly } from "../hook/useDocument";
// import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Switch } from "@/components/ui/switch";
import { toast } from "@/hooks/use-toast";
import { useEffect, useMemo, useState } from "react";
// import { getObject } from "@/lib/object-mutation";

export const IgnorePriceValidationColumn = ({
  data,
  parentKey,
  arr,
  review_required_row_no,
  // temp_reviewed,
  // data_review_required,
}: {
  parentKey: string;
  data: any;
  review_required: any;
  review_required_row_no: any;
  arr: any;
}) => {
  const [
    state,
    _setState,
    _searchAddress,
    _updateAddress,
    _searchSupplier,
    _updateSupplierMapping,
    _searchItemMaster,
    _updateItemMaster,
    _mutationMasterData,
    _onUpdateIsSimilarityMatch,
    onIgnorePriceValidations,
    ignorePriceValidations,
  ] = useDocument();

  // Void and deleted documents are read-only
  const isVoid = useDocumentReadOnly();

  const customer_id =
    ignorePriceValidations?.customer_mapping?.text?.customer_id;

  const itemMaster = arr?.["item_master"];

  const onCheckedChange = (prop: any, index: number) => {
    const selectedItem = itemMaster?.[index]?.text;
    if (!customer_id) {
      toast({
        title: "Error",
        variant: "destructive",
        description: "Customer Mapping is required",
      });
      return null;
    }
    if (!selectedItem || selectedItem === "") {
      toast({
        title: "Error",
        variant: "destructive",
        description: "Item Master is  required",
      });
      return null;
    }
    const existingCustomerIds =
      ignorePriceValidations?.ignore_price_validations?.[customer_id] ?? [];
    const updatedItem = {
      ...ignorePriceValidations?.ignore_price_validations,
      [customer_id]: prop
        ? [...existingCustomerIds, selectedItem]
        : existingCustomerIds?.filter((id: any) => id !== selectedItem),
    };
    onIgnorePriceValidations(updatedItem);
  };

  if (!ignorePriceValidations?.erp_price_validations) {
    return null;
  }
  return (
    <>
      <div className="relative">
        <div
          className={cn(
            "text-[14px]  pr-2 min-w-[10px] w-full  bg-gray-100 font-semibold relative text-left py-[5px] h-[46px] ",
            "pt-[5px]",
          )}
        >
          <div className="flex   flex-col pl-[16px]">
            Ignore Price <br />
            Validation
          </div>
        </div>
        {data?.map((item: any, index: number) => {
          if (item?.is_deleted) {
            return null;
          }

          return (
            <CheckedItem
              review_required_row_no={review_required_row_no}
              item={item}
              onCheckedChange={onCheckedChange}
              index={index}
              key={index}
              ignorePriceValidations={
                ignorePriceValidations?.ignore_price_validations
              }
              selectedItem={itemMaster?.[index]?.text}
              customer_id={customer_id}
              disabled={isVoid}
            />
          );
        })}
      </div>
    </>
  );
};

const CheckedItem = ({
  review_required_row_no,
  item,
  onCheckedChange,
  ignorePriceValidations,
  index,
  selectedItem,
  customer_id,
  disabled,
}: any) => {
  const checked = ignorePriceValidations?.[customer_id]?.includes(selectedItem);
  console.log({ checked });
  return (
    <div
      className={cn(
        "w-full text-center relative h-[40px] ",
        review_required_row_no?.includes(item?.row_number)
          ? // isReviewRequired && currentReviewed.text === "false"
            "bg-[#fef2f2] pt-[5px]"
          : "odd:bg-gray-50 bg-white pt-[3px]",
      )}
      key={index}
    >
      <div className="text-[14px] p-[6px] flex  items-center gap-2 ">
        <span className="pl-[10px]">
          <Switch
            checked={checked ? true : false}
            disabled={disabled}
            onCheckedChange={(prop) => onCheckedChange(prop, index)}
          />
        </span>
      </div>
    </div>
  );
};
